import { useState } from "react";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import useSignOut from "react-auth-kit/hooks/useSignOut";
import { useMatch, useNavigate } from "react-router-dom";
import { PageContext } from "./page";

const PageContextProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [headerText, setHeaderText] = useState(null);

  const isAuth = useIsAuthenticated();
  const signOut = useSignOut();
  const navigate = useNavigate();
  const match = useMatch("/");

  const handleSignOut = () => {
    signOut();
    navigate("/login");
  };

  if (!isAuth) {
    handleSignOut();
  }

  // If a user visits "/" redirect them to "/dashboard" instead
  // so that the right component is rendered in the view,
  // this is due to how private routes have been set up.
  if (Boolean(match)) navigate("/dashboard");

  return (
    <PageContext.Provider
      value={{ loading, headerText, setLoading, setHeaderText }}
    >
      {children}
    </PageContext.Provider>
  );
};

export default PageContextProvider;
